<template>
  <div class="menu custom-menu">
    <ul class="menu-list">
      <li>
        <router-link to="/dashboard" :class="{'click-menu': $route.path === '/dashboard'}" class="hover-menu">
          <span class="mdi mdi-home mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">ダッシュボード</span>
        </router-link>
      </li>
      <li class="list-direct" @mouseover="mouseoverDirect"  @mouseleave="mouseleaveDirect">
        <router-link to="/dashboard/directtalk/scout" :class="{'click-menu': $route.path === '/dashboard/directtalk/scout'}" class="hover-menu">
          <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">ダイレクトスカウト</span>
        </router-link>
        <ul class="dropdown-list" v-if="ListDirectFlg">
          <li>
            <router-link to="/dashboard/directtalk/scout" :class="{'click-submenu': $route.path === '/dashboard/directtalk/scout'}">
              <i class="mdi mdi-send mdi-18px icon"></i>
              ダイレクトスカウト
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/directtalk" :class="{'click-submenu': $route.path === '/dashboard/directtalk'}">
              <i class="mdi mdi-comment-multiple-outline mdi-18px icon"></i>
              訪問者会話
            </router-link>
          </li>
        </ul>
      </li>
      <li class="list-bot" @mouseover="mouseoverListBot"  @mouseleave="mouseleaveListBot">
        <router-link to="/dashboard/chatbot?pages=1&recruit=true" :class="{'click-menu': $route.path === '/dashboard/chatbot'}" class="hover-menu">
          <span class="mdi mdi-robot mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">ロボ一覧画面</span>
        </router-link>
        <ul class="dropdown-list" v-if="ListBotFlg">
          <li>
            <router-link to="/dashboard/chatbot">
              <i class="mdi mdi-garage mdi-18px icon"></i>
              ロボ倉庫画面
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/chatbot?view=sitemap">
              <i class="mdi mdi-power-plug mdi-18px icon"></i>
              起動設定画面
            </router-link>
          </li>
          <li @click="moveToScenarioTop()" v-if="chatbots.length > 0 && !isCBLoading">  
            <p class="link">
              <i class="mdi mdi-notebook mdi-18px icon"></i>
              シナリオ画面
            </p>
          </li>
          <li v-if="isCBLoading">
            <p class="link">
              <i class="mdi mdi-notebook mdi-18px icon"></i>
              シナリオ画面
            </p>
          </li>
        </ul>
      </li>
      <li>
        <router-link to="/dashboard/story" :class="{'click-menu': $route.path === '/dashboard/story'}" class="hover-menu">
          <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">求人ノベル</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/employment/list?pages=1&recruit=true" :class="{'click-menu': $route.path === '/dashboard/employment/list'}" class="hover-menu">
          <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">求人作成</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/videoview" :class="{'click-menu': $route.path === '/dashboard/videoview'}" class="hover-menu">
          <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">ウェブ会議（β版）</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/mediapool" :class="{'click-menu': $route.path === '/dashboard/mediapool'}" class="hover-menu">
          <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">メディア倉庫</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/manage" :class="{'click-menu': $route.path.indexOf('/dashboard/manage') !== -1}" class="hover-menu">
          <span class="mdi mdi-account-group mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">応募者管理</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/calendar" :class="{'click-menu': $route.path === '/dashboard/calendar'}" class="hover-menu">
          <span class="mdi mdi-calendar-today mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">カレンダー</span>
        </router-link>
      </li>
      <li class="list-setting" @mouseover="mouseoverSetting"  @mouseleave="mouseleaveSetting">
        <router-link to="/dashboard/setting/personal" :class="{'click-menu': $route.path.indexOf('/dashboard/setting/') !== -1}" class="hover-menu">
          <span class="mdi mdi-settings mdi-24px mdi-light" style="margin-right: 7px;"></span>
          <span style="color: white;">設定</span>
        </router-link>
        <ul class="dropdown-list" v-if="ListSettingFlg">
          <li>
            <router-link to="/dashboard/setting/personal" :class="{'click-submenu': $route.path === '/dashboard/setting/personal'}">
              個人設定
            </router-link>
          </li> 
          <li>
            <router-link to="/dashboard/setting/common" :class="{'click-submenu': $route.path === '/dashboard/setting/common'}">
              共通設定
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/setting/app_icon" :class="{'click-submenu': $route.path === '/dashboard/setting/app_icon'}">
              アプリアイコン
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/setting/other_api" :class="{'click-submenu': $route.path === '/dashboard/setting/other_api'}">
              外部連携
            </router-link>
          </li>
          <!-- ユーザー一覧は管理者権限のユーザーのみ表示 -->
          <li v-if="user.permission === 0">
            <router-link to="/dashboard/setting/user_list" :class="{'click-submenu': $route.path === '/dashboard/setting/user_list'}">
              ユーザー権限/追加
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/setting/company" :class="{'click-submenu': $route.path === '/dashboard/setting/company'}">
              会社情報
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import session from '@/api/session'
export default {
  name: 'DashBoardMainMenu',
  componentName: 'DashBoardMainMenu',
  /* *
   * User Data 情報取得
   * 初期構築
   * */
  data () {
    return {
      ListBotFlg: false,
      ListSettingFlg: false,
      ListDirectFlg: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('directtalk', ['chatData', 'isConnectList']),
    ...mapState('chatbot', ['chatbots', 'isCBLoading']),
    ...mapState('sitemap', ['isFirstLoad', 'firstLoadCount']),
    ...mapState('virtualOffice', ['isVOConnectList']),
  },
  watch: {
    isConnectList: function () {
      if (!this.isConnectList) {
        var uri = process.env.WS_ENDPOINT + 'list/' + this.user.companyID + '/' + this.user.email
        this.$store.dispatch('directtalk/connectList', uri)
      }
    },
    isVOConnectList () {
      if (!this.isVOConnectList) {
        setTimeout(() => {
          const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
          this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
        }, 5000)
      }
    },
  },
  updated () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  methods: {
    mouseoverDirect () {
      this.ListDirectFlg = true
    },
    mouseleaveDirect () {
      this.ListDirectFlg = false
    },
    mouseoverListBot () {
      this.ListBotFlg = true
    },
    mouseleaveListBot () {
      this.ListBotFlg = false
    },
    mouseoverSetting () {
      this.ListSettingFlg = true
    },
    mouseleaveSetting () {
      this.ListSettingFlg = false
    },
    moveToScenarioTop () {
      let chatbot = this.chatbots.find((bot)=>!bot.is_archive) || this.chatbots[0]
      this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: chatbot.scenario_name })
      this.$store.dispatch('chatbot/selectChatbot', chatbot)
      this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + chatbot.scenario_name)
    },
  },
  destroyed () {
    setTimeout(() => {
      this.$store.dispatch('virtualOffice/disconnectVirtualOfficeSV')
    }, 500)
  },
  created () {
    console.debug('*** Start *** created')
    this.$store.dispatch('auth/getcreateManage')
    this.$store.dispatch('sitemap/getSitemapEmploymentListAll')
    this.$store.dispatch('sitemap/getSitemapRoboList')
    this.$store.dispatch('sitemap/getEmploymentTagList')
    this.$store.dispatch('sitemap/getSitemapRootList')
    this.$store.dispatch('sitemap/getSitemapWaitList')
    this.$store.dispatch('sitemap/getSitemapRecruitListAll')
    this.$store.dispatch('sitemap/getSitemapCustomListAll')
    if (this.$route.query.pages !== undefined) {
      if (this.$route.query.pages >= 1) {
        let pages = Number(this.$route.query.pages)
        const recruitPageData = {
          pages       : pages,
          per_page    : 30,
          content_type: 4
        }
        this.$store.dispatch('sitemap/getSitemapRecruitList', recruitPageData)
        const customPageData = {
          pages       : pages,
          per_page    : 30,
          content_type: 5
        }
        this.$store.dispatch('sitemap/getSitemapCustomList', customPageData)
      }
    } else {
      const recruitPageData = {
        pages       : 1,
        per_page    : 30,
        content_type: 4
      }
      this.$store.dispatch('sitemap/getSitemapRecruitList', recruitPageData)
      const customPageData = {
        pages       : 1,
        per_page    : 30,
        content_type: 5
      }
      this.$store.dispatch('sitemap/getSitemapCustomList', customPageData)
    }
    this.$store.dispatch('mediapool/getAllImages')
    this.$store.dispatch('mediapool/getAllVideos')
    this.$store.dispatch('auth/getCompanyEmailTemplate', null)
    this.$store.dispatch('auth/getCompanyColumnSetting', null)
    this.$store.dispatch('auth/getCompanyRecruit', null)
    this.$store.dispatch('chatbot/getChatBots')
    this.$store.dispatch('chatbot/getRoboPartsSet', this.user.companyID)
    this.$store.dispatch('chatbot/getStory')
    this.$store.dispatch('auth/getScout')
    this.$store.dispatch('auth/getRecruitmentFlow')
    this.$store.dispatch('directtalk/getSeeker', 'subscribe')
    this.$store.dispatch('auth/getGoogleDriveAuthStatus')
    this.$store.dispatch('employmentPage/getRootContent')
    var con = {
      'is_connect': true
    }
    this.$store.dispatch('auth/setUserConnect', con)
    var star = {
      'get_type': 'star'
    }
    var search = {
      'get_type': 'search',
      'init': 'ok'
    }
    var all = {
      'get_type': 'all'
    }
    this.$store.dispatch('directtalk/getRoomList', star)
    this.$store.dispatch('directtalk/getRoomList', search)
    this.$store.dispatch('directtalk/getRoomList', all)
    this.$store.dispatch('auth/getStoreCateogry')
    this.$store.dispatch('auth/getUsers')
    this.$store.dispatch('auth/getSlackStatus')
    this.$store.dispatch('auth/getCWStatus')
    this.$store.dispatch('auth/getGoogleDriveAuthStatus')
    this.$store.dispatch('chatbot/getChatBotStoreItem')
    this.$store.dispatch('calendar/getGoogleCalendar')
    this.$store.dispatch('calendar/getGaroonCalendar')
    this.$store.dispatch('calendar/getGybozuCalendar')
    this.$store.dispatch('calendar/getMSOfficeCalendar')
    this.$store.dispatch('auth/getUsersStatusAPI')
    var uri = process.env.WS_ENDPOINT + 'list/' + this.user.companyID + '/' + this.user.email
    this.$store.dispatch('directtalk/connectList', uri)
    this.$store.dispatch('calendar/getSchedule', {email: this.user.email, companyHash: this.user.companyID})
    console.debug('*** End *** created')
  },
}
</script>

<style lang="scss" scoped>
.custom-menu {
  background: #AA0066;
  width: 200px;
  height: calc(100vh - 80px) !important; margin: 0 !important;
  display: flex;
  text-align: left;
  z-index: 10;
}
.menu-list {
  width: 200px;
  font-size: smaller;
}
.click-menu {
  background: rgba(150, 140, 140, 0.8) !important;
}
.hover-menu {
  color: white;
  transition: 0.5s;
}
.hover-menu:hover {
  background: rgba(150, 140, 140, 0.8) !important;
}
.list-direct {
  position: relative;
}
.list-bot {
  position: relative;
}
.list-setting {
  position: relative;
}
.dropdown-list {
  width: 200px;
  position: absolute;
  top: 0;
  left: 200px;
  line-height:30px;
  background-color: #f8f8f8;
  border: 0.7px solid rgba(150, 140, 140, 0.8);
  box-shadow: 3px 3px 10px rgba(0,0,0,0.2);
  border-left: none;
  z-index: 10;
  a,.link {
    padding: 8px;
    border-radius: 2px;
    border-bottom: solid 0.7px rgba(150, 140, 140, 0.8);
  }
  a:hover,.link:hover {
    background: rgba(150, 140, 140, 0.8);
    color: #fff;
    cursor: pointer;
  }
  .icon {
    margin-right: 4px;
  }
}
.menu-list li ul {
    border-left: none;
    margin: 0;
    padding: 0;
}
.click-submenu {
  color: #fff;
  background: rgba(150, 140, 140, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DashBoardMainMenu.vue